import { render, staticRenderFns } from "./DateSectionEditor.vue?vue&type=template&id=217ae28d"
import script from "./DateSectionEditor.vue?vue&type=script&lang=ts"
export * from "./DateSectionEditor.vue?vue&type=script&lang=ts"
import style0 from "./DateSectionEditor.vue?vue&type=style&index=0&id=217ae28d&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports